<template>
  <Button
    :variant="variant"
    :size="size"
    :class="
      cn(
        'gradient-button',
        {
          'gradient-button--full-width': fullWidth,
          'gradient-button--multiline whitespace-normal h-auto': multiline,
        },
        props.class
      )
    "
    v-bind="$attrs"
  >
    <slot />
  </Button>
</template>

<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { Button } from '@/lib/ui/button'
import { cn } from '@/lib/ui/utils'
import type { ButtonVariants } from '@/lib/ui/button'

interface IGradientButtonProps {
  variant?: ButtonVariants['variant']
  size?: ButtonVariants['size']
  class?: HTMLAttributes['class']
  fullWidth?: boolean
  multiline?: boolean
}

const props = withDefaults(defineProps<IGradientButtonProps>(), {
  variant: 'default',
  size: 'default',
  fullWidth: false,
  multiline: false,
})

defineOptions({
  inheritAttrs: false,
})
</script>

<style>
.gradient-button {
  background: linear-gradient(
    135deg,
    hsl(var(--primary) / 0.05) 0%,
    hsl(var(--primary) / 0.08) 25%,
    rgba(255, 255, 255, 0.9) 50%,
    hsl(var(--primary) / 0.06) 75%,
    hsl(var(--primary) / 0.04) 100%
  ) !important;
  color: hsl(var(--primary)) !important;
  font-weight: 600 !important;
  border: 1px solid hsl(var(--primary) / 0.15) !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05) !important;
}

.gradient-button:hover {
  background: linear-gradient(
    135deg,
    hsl(var(--primary) / 0.08) 0%,
    hsl(var(--primary) / 0.12) 25%,
    rgba(255, 255, 255, 0.85) 50%,
    hsl(var(--primary) / 0.1) 75%,
    hsl(var(--primary) / 0.06) 100%
  ) !important;
  color: hsl(var(--primary) / 0.9) !important;
  border: 1px solid hsl(var(--primary) / 0.25) !important;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08) !important;
}

.gradient-button--full-width {
  width: 100%;
}

.gradient-button--multiline {
  white-space: normal !important;
  word-wrap: break-word;
  overflow-wrap: break-word;
  height: auto !important;
  min-height: 2rem;
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
  line-height: 1.4;
  text-align: left;
}

.gradient-button--multiline.h-8 {
  height: auto !important;
  min-height: min-content !important;
}
</style>
